module.exports = __webpack_public_path__ + "img/galet_marbre_blanc.0264cfd4.jpg";